module.exports = __webpack_public_path__ + "img/23.ce98ae99.gif";